// extracted by mini-css-extract-plugin
export default {"cartSendContainer":"CartSend_cartSendContainer__Zp0e-","cartSend":"CartSend_cartSend__YVOZV","containerForm":"CartSend_containerForm__zdAC3"};